import * as Sentry from "@sentry/react";
import resolveConfig from "tailwindcss/resolveConfig";
import tailwindConfigModule from "../../tailwind.config";

export const tailwindConfig = resolveConfig(tailwindConfigModule);

// @ts-expect-error
export const hexToRGB = (h) => {
  let r = "";
  let g = "";
  let b = "";
  if (h.length === 4) {
    r = `0x${h[1]}${h[1]}`;
    g = `0x${h[2]}${h[2]}`;
    b = `0x${h[3]}${h[3]}`;
  } else if (h.length === 7) {
    r = `0x${h[1]}${h[2]}`;
    g = `0x${h[3]}${h[4]}`;
    b = `0x${h[5]}${h[6]}`;
  }
  return `${+r},${+g},${+b}`;
};

// @ts-expect-error
export const formatValue = (value) =>
  Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    maximumSignificantDigits: 3,
    notation: "compact",
  }).format(value);

// @ts-expect-error
export const formatALGO = (value) => `${value.toFixed(2)} ALGO`;

// @ts-expect-error
export const formatPercentage = (value) => `${value.toFixed(2)} %`;

// @ts-expect-error
export const formatNumber = (value) => `${value.toFixed(2)}`;

// @ts-expect-error
export const formatBids = (value) => value;

// @ts-expect-error
export const formatRating = (value) => value;

export const sentryWrappedException = (exc: Error) => {
  if (process.env.NODE_ENV === "production") {
    Sentry.captureException(exc);
  } else {
    // eslint-disable-next-line no-console
    console.error(exc);
  }
};

export const getAuthType = (isAuthenticated: boolean) => {
  return isAuthenticated ? "auth0" : "web3";
};

export function classNames(...classes: string[]) {
  return classes.filter(Boolean).join(" ");
}
